<template>
  <div class="pdf-container">
    <div class="canvas-panel"
         v-loading="loading">

      <canvas id="pdf-canvas"></canvas>
    </div>
    <div class="pagination-controls">
      <button @click="goPrevious"
              :disabled="!canGoPrevious">上一页</button>
      <span>第 {{ currentPage }} 页，共 {{ pages }} 页</span>
      <button @click="goNext"
              :disabled="!canGoNext">下一页</button>
    </div>
  </div>
</template>

<script>
import PDF from "pdfjs-dist";
PDF.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
PDF.disableWorker = true;
export default {
  props: {
    value: {
      default: {
        show: false,
        url: String
      }
    }
  },
  data () {
    return {
      pdfDoc: null,
      pages: 0,
      currentPage: 1,
      canGoPrevious: false,
      canGoNext: true,
      loading: true
    };
  },
  async mounted () {
    const url = this.value.url // Replace with your PDF URL
    this.loadFile(url);
  },
  methods: {
    renderPage (num) {
      this.pdfDoc.getPage(num).then((page) => {
        this.loading = true
        let canvas = document.getElementById("pdf-canvas");
        let ctx = canvas.getContext("2d");
        let dpr = window.devicePixelRatio || 1; // 设备像素比
        let bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1; // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
        let ratio = dpr / bsr;
        let viewport = page.getViewport(1.5, 0);
        canvas.width = viewport.width * ratio; // 画布大小,默认值是width:300px,height:150px
        canvas.height = viewport.height * ratio;
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };
        page.render(renderContext).promise.then(() => {
          console.log('加载单独')
          // Page rendered
          this.loading = false
        });
      });
    },
    async loadFile (url) {
      try {
        const pdf = await PDF.getDocument(url).promise;
        this.pdfDoc = pdf;
        this.pages = this.pdfDoc.numPages;
        this.renderPage(this.currentPage);
      } catch (error) {
        console.error("Error loading PDF: ", error);
      }
    },
    goPrevious () {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.renderPage(this.currentPage);
      }
    },
    goNext () {
      if (this.currentPage < this.pages) {
        this.currentPage++;
        this.renderPage(this.currentPage);
      }
    },
  },
  watch: {
    currentPage (newVal) {
      this.canGoPrevious = newVal > 1;
      this.canGoNext = newVal < this.pages;
    },
  },
};
</script>

<style lang="stylus" scoped>
.pdf-container {
  width: 100%;
  height: 100%;
  position: relative;
  .canvas-panel {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    canvas {
      margin: 0 auto;
      display: block; // Ensures canvas is centered
    }
  }
  .pagination-controls {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    color: #fff;
    justify-content: center;
    margin-bottom: 10px;
    button {
      margin: 0 10px;
      background: none;
      padding: 5px 10px;
    }
  }
}
</style>